const NotFound = () => {
    return (
        <h>Not found</h>
    );
};

export default NotFound;